import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=0b13f69e&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./report-card.css?vue&type=style&index=0&lang=css&"
import style1 from "./add.css?vue&type=style&index=1&id=0b13f69e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b13f69e",
  null
  
)

export default component.exports